import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
} from "react-router-dom";
import Login from "./Pages/Login";
import { PrimaryMenu } from "./Components/PrimaryMenu";
import { ProtectedRoute } from "./Components/Protected.route";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import PasswordChange from "./Components/UserProfile/PasswordChange";
import UserProfile from "./Components/UserProfile/UserProfile";
import ArtisanLogin from "./Pages/ArtisanLogin";
import ArtisanDelete from "./Pages/ArtisanDelete";
import "./assets/script";
import LoaderOverlay from "./LoaderOverlay";
import NoPermission from "./Components/NoPermission";
import Abc from "./Pages/Abc";
import InvoicePage from "./Pages/InvoicePage";
import PermissionCheck from "./Components/PermissionCheck";
import ScrollByArrow from "./ScrollByArrow";
import KeyboardInputFix from "./Utils/KeyboardInputFix";
import { LoaderProvider } from "./Loader";

function App() {
  return (
    <>
      <LoaderProvider>
        <LoaderOverlay />
        <KeyboardInputFix />
        <Router basename="/">
          <ScrollByArrow>
            <PermissionCheck />
            <Routes>
              {PrimaryMenu.map((item, index) => {
                if (!("submenu" in item)) {
                  return (
                    <Route
                      key={index}
                      exact
                      path={item.path}
                      element={<ProtectedRoute />}
                    >
                      <Route exact path={item.path} element={item.comp} />
                    </Route>
                  );
                } else {
                  return (
                    <Route
                      path={item.path}
                      key={index}
                      element={<ProtectedRoute />}
                    >
                      <Route index={true} element={item.comp} key={index} />
                      {item.submenu.map((subitem, subindex) => {
                        return (
                          <Route
                            exact
                            path={subitem.path}
                            element={subitem.comp}
                            key={subindex}
                          />
                        );
                      })}
                    </Route>
                  );
                }
              })}
              ;
              <Route path="/" exact element={<Login />} key="login" />
              <Route
                path="/artisan"
                exact
                element={<ArtisanLogin />}
                key="artisanLogin"
              />
              <Route
                path="/artisan/delete"
                exact
                element={<ArtisanDelete />}
                key="artisan-delete"
              />
              <Route
                path="/forgot-password"
                exact
                element={<ForgotPassword />}
                key="forgot-password"
              />
              <Route
                path="/no-permission"
                exact
                element={<NoPermission />}
                key="no-permission"
              />
              <Route
                path="/reset-password/:token"
                exact
                element={<ResetPassword />}
                key="reset-password"
              />
              <Route
                path="/invoice"
                exact
                element={<InvoicePage />}
                key="invoice"
              />
              <Route path="/profile" element={<ProtectedRoute />}>
                <Route index={true} element={<UserProfile />} />
              </Route>
              <Route path="/change-password" element={<ProtectedRoute />}>
                <Route index={true} element={<PasswordChange />} />
              </Route>
            </Routes>
          </ScrollByArrow>
        </Router>
      </LoaderProvider>
    </>
  );
}

export default App;
